import _ from 'lodash';

function mapPart(part: number) {
    const roundedPart = _.round(part, 3);
    return _.round(roundedPart * 3);
}

/**
 * convert innings in inning format `(=0.0, 0.1, 0.2)` to fraction format `(0/3, 1/3, 2/3)`
 */
export function convertInningToFraction(inning: string): number {
    return _.round(convertInningToOuts(inning) / 3, 3);
}
/**
 * convert innings in fraction format `0/3, 1/3, 2/3` to inning format `0.0, 0.1, 0.2`
 */
export function convertFractionToInning(fraction: number): string {
    const roundedFraction = _.round(fraction, 3);
    const whole = Math.floor(roundedFraction);
    const part = mapPart(roundedFraction - whole);
    return whole + '.' + part;
}
/**
 * convert innings in fraction format `0/3, 1/3, 2/3` to number of outs
 */
export function convertFractionToOuts(fraction: number): number {
    const inning = convertFractionToInning(fraction);
    return convertInningToOuts(inning);
}
/**
 * convert innings in inning format `0.0, 0.1, 0.2` to number of outs
 */
export function convertInningToOuts(inning: string): number {
    const [wholeAsStr, partAsStr] = inning.split('.');
    const wholeAsInt = parseInt(wholeAsStr) || 0;
    const partAsInt = (partAsStr && parseInt(partAsStr)) || 0;

    return wholeAsInt * 3 + partAsInt;
}
